export default {
    upload: '/common/upload', // 上传图片
    typeList: '/common/type/list', // 获取身份类型
    baseInfo: '/admin/config/get', // 基础配置
    setConfig: '/admin/config/set', // 基础配置
    picbase64: '/common/picbase64', // 获取图片base64
    getArea: '/common/address/area', // 获取省、市、区
    getCode: '/common/wx/mini/code', // 生成微信小程序码
    sendSms: '/common/send/sms/code',

    // 登录
    manageLogin: '/admin/rule/user/login', // 登录

    setOption: '/admin/conf/batch/set', // 批量配置参数
    getOption: '/admin/conf/batch/get', // 批量读取配置参数

    getCongfigList: '/admin/conf/list',
    getCongfigGroupList: '/admin/conf/group/list',
    setConfig: '/admin/conf/batch/set',
    deleteConfig: '/admin/conf/delete',

    managerLogout: '/admin/rule/user/logout',
    getCaptchaImg: '/common/captcha', // 获取登录图片验证码

    uploadPay: '/admin/pay/merchant/info/upload',

    // 账号管理
    managerList: '/admin/admin/user/list', // 管理员列表
    addManager: '/admin/admin/user/add', // 添加管理员
    editManager: '/admin/admin/user/modify', // 修改管理员信息
    editPassword: '/admin/admin/user/password', // 修改管理员密码
    editManagerStatus: '/admin/admin/user/status', // 管理员状态更改

    // 权限管理
    powerGroupList: '/admin/admin/group/list', // 权限组列表
    deletePowerGroup: '/admin/admin/group/delete', // 删除权限组
    powerList: '/admin/admin/acl/list', // 所有权限列表
    choiceGroupPower: '/admin/admin/group/acls', // 权限组所属权限列表
    editGroupPower: '/admin/admin/group/acl', // 权限组权限修改
    powerGroupMember: '/admin/admin/group/users', // 权限组成员列表
    choiceManagerGroup: '/admin/admin/user/groups', // 管理员所属组列表
    editManagerGroup: '/admin/admin/user/group', // 管理员所属组修改列表

    // 菜单维护
    menuList: '/admin/rule/menu/list', // 菜单列表
    addMenu: '/admin/rule/menu/add', // 菜单添加
    editMenu: '/admin/rule/menu/edit', // 菜单编辑
    deleteMenu: '/admin/rule/menu/delete', // 菜单删除
    managerMenu: '/admin/rule/permission/menu/available/list', // 有权限的菜单列表(根据登录的管理员获取的菜单列表)



    //----------------------------------- 组织架构 --------------------------------------------------------

    getOrgStructList: '/admin/org/struct/list',
    updateOrgStruct: '/admin/org/struct/edit',
    deleteOrgStruct: '/admin/org/struct/delete',
    addOrgStruct: '/admin/org/struct/add',
    bindingSuperior: '/admin/user/binding/superior',




    addMember: '/admin/rule/user/add',
    updateMember: '/admin/rule/user/edit',
    getMemberList: '/admin/rule/user/list',
    getGroupListByUser: '/admin/rule/permission/user/group/list',
    freezeUser: '/admin/rule/user/freeze',
    unfreezeUser: '/admin/rule/user/unfreeze',



    // 合作伙伴
    getPartnerList: '/admin/partner/list',
    getPartnerInfo: '/admin/partner/info',
    addPartner: '/admin/partner/create',
    updatePartner: '/admin/partner/update',



    //权限组
    getGroupList: '/admin/rule/permission/group/list',
    addGroup: '/admin/rule/permission/add/group',
    deleteGroup: '/admin/rule/permission/delete/group',
    bindGroup: '/admin/rule/permission/link/user',

    getPermissionMenuList: '/admin/rule/permission/menu/optional/list',
    updatePermissionMenu: '/admin/rule/permission/menu/link',
    getPermissionApiList: '/admin/rule/permission/api/optional/list',
    updatePermissionApi: '/admin/rule/permission/api/link',

    //api管理
    getApiList: '/admin/rule/api/list',
    addApi: '/admin/rule/api/add',
    deleteApi: '/admin/rule/api/delete',
    updateApi: '/admin/rule/api/edit',
    readApi: '/admin/rule/api/read',



    //字典
    getDictionaryList: '/admin/dictionary/list',
    addDictionary: '/admin/dictionary/create',
    deleteDictionary: '/admin/dictionary/delete',
    updateDictionary: '/admin/dictionary/update',
    lockDictionary: '/admin/dictionary/lock',

    //字典项
    addDictionaryItem: '/admin/dictionary/item/create',
    getDictionaryItem: '/admin/dictionary/info',
    deleteDictionaryItem: '/admin/dictionary/item/delete',
    updateDictionaryItem: '/admin/dictionary/item/update',
    lockDictionaryItem: '/admin/dictionary/item/lock',

    getDictionaryByName: '/admin/dictionary/item/list/son',












    // 用户
    getUserList: '/admin/user/list', // 用户列表
    userDetail: '/admin/user/info', // 用户详情
    getPopularizeList: '/admin/user/generalize/list', // 推广用户列表
    updateUserStatus: '/admin/user/status/set',
    getAgentListNew: '/admin/team/list', // 代理商列表
    openAgentNew: '/admin/team/open', // 开通代理商
    closeAgentNew: '/admin/team/close', // 关闭代理商
    agentRecordNew: '/admin/team/log/list', // 代理商开通记录列表
    // updateHz: '/admin/user/integral/update',
    addKpi: '/admin/user/kpi/update',

    getVipList: '/admin/user/vip/list',

    addSetQuota: '/admin/quota/set/add',

    updateQuota: '/admin/quota/update',

    getVicePresidentList: '/admin/user/vice/president/list',
    getPresidentList: '/admin/user/president/list',
    

    getAreaAgentList: '/admin/user/agent/area/list',
    getAreaAgentRecord: '/admin/user/role/agent/log',
    closeRole: '/admin/user/role/cancel',
    updateAgentTime: '/admin/user/agent/time/Update',

    getAgentExamineList: '/admin/user/agent/list',

    passAgentOne: '/admin/user/agent/pass/one',
    passAgentTwo: '/admin/user/agent/pass/two',
    refuseAgentOne: '/admin/user/agent/refuse/one',
    refuseAgentTwo: '/admin/user/agent/refuse/two',



    getAgentList: '/admin/user/role/list', // 代理商管理列表
    openAgent: '/admin/user/role/open', // 开通代理商
    agentRecord: '/admin/user/role/log/list', // 代理商开通记录列表
    closeAgent: '/admin/user/role/close', // 关闭代理商

    getYyzxList: '/admin/user/company/son/list', // 运营中心审核列表
    yyzxResolve: '/admin/user/company/son/pass', // 运营中心审核通过
    yyzxReject: '/admin/user/company/son/refuse', // 运营中心审核拒绝
    yyzxInfo: '/admin/user/company/son/info', // 运营中心详情

    getFgsList: '/admin/user/company/list', // 分公司审核列表
    fgsResolve: '/admin/user/company/pass', // 分公司审核通过
    fgsReject: '/admin/user/company/refuse', // 分公司审核拒绝
    fgsInfo: '/admin/user/company/info', // 分公司详情

    // 商品管理
    getGoodsList: '/admin/goods/list', // 商品列表
    getGoodsImportList: '/admin/goods/list/export', // 商品列表
    goodsDetail: '/admin/goods/info', // 商品详情
    createGoods: '/admin/goods/add', // 创建商品
    editGoods: '/admin/goods/edit', // 编辑商品
    deleteGoods: '/admin/goods/delete', // 编辑商品
    updateGoodsStatus: '/admin/goods/set/status', // 修改商品状态
    batchUpdateGoodsStatus: '/admin/goods/set/status/batch',

    getGoodsCategoryList: '/admin/goods/sort/list', // 获取商品分区列表
    updateFirstCategory: '/admin/goods/sort/update/first', // 添加商品分区
    deleteFirstCategory: '/admin/goods/sort/delete/first', // 删除商品分区
    updateSecondCategory: '/admin/goods/sort/update/second', // 添加二级商品分区
    deleteSecondCategory: '/admin/goods/sort/delete/second', // 删除二级商品分区
    changeRecommend: '/admin/goods/sort/update/recommend', // 更新是否推荐
    updateGoodsTwig: '/admin/goods/set/twig', // 设置商品排
    changeCategoryOpen: '/admin/goods/sort/update/open', // 更新是否开启

    getPriceInfo: '/admin/range/get/price',
    setPriceInfo: '/admin/range/set/price',
    getShowInfo: '/admin/range/get/visibility',
    setShowInfo: '/admin/range/set/visibility',

    getFreightList: '/admin/freight/list', // 运费模板列表
    getFreightInfo: '/admin/freight/info', // 运费模板详情
    addFreight: '/admin/freight/add', // 创建运费模板
    updateFreight: '/admin/freight/update', // 编辑运费模板
    deleteFreight: '/admin/freight/delete',

    getNoDeliver: '/admin/deliver/info', // 不发货地区详情
    setNoDeliver: '/admin/deliver/update', // 编辑不发货地区

    // 店铺装修
    getBannerList: '/admin/setup/banner/list', // 轮播图列表
    addBanner: '/admin/setup/banner/add', // 添加轮播图
    updateBanner: '/admin/setup/banner/update', // 编辑轮播图
    deleteBanner: '/admin/setup/banner/delete', // 删除轮播图

    // 分享设置
    getShareInfo: '/admin/setup/share/info', // 分享详情
    updateShare: '/admin/setup/share/update', // 修改分享

    // 图文设置
    getArticleList: '/admin/setup/teletext/list', // 图文设置列表
    updateArticle: '/admin/setup/teletext/update', // 图文设置更新
    articleInfo: '/admin/setup/teletext/info', // 图文设置详情

    // 资金相关===================================
    getWithdrawList: '/admin/draw/log/list', // 审核列表
    getWithdrawInfo: '/admin/draw/log/info', // 审核詳情
    refuteWithdraw: '/admin/draw/log/refute',
    passWithdraw: '/admin/draw/log/pass',

    getWithdrawList2: '/admin/draw/kpi/log/list', // 审核列表
    getWithdrawInfo2: '/admin/draw/kpi/log/info', // 审核詳情
    refuteWithdraw2: '/admin/draw/kpi/log/refute',
    passWithdraw2: '/admin/draw/kpi/log/pass',

    getWithdrawAudit: '/admin/withdraw/audit', // 审核結果
    getQuotaList: '/admin/fund/quota/log/list', // 配额记录
    fundQuota: '/admin/fund/recharge/quota', // 配额充值
    getRebateList: '/admin/fund/rebate/log', // 分润记录
    getFinancialCounting: '/admin/fund/financial/counting', // 财务对账
    integralList: '/admin/fund/integral/log/list', // 财务对账
    batchList: '/admin/global/batch/list', // 全球分红批次列表
    poolList: '/admin/global/pool/list', // 全球分红奖池列表
    perList: '/admin/global/per/list', // 全球分红记录
    confirmRelease: '/admin/global/confirm/release', // 全球分红记录

    getIntegralList: '/admin/fund/integral/list', // 积分变动记录
    getGoldList: '/admin/fund/gold/list', // 华金变动记录
    getBalance: '/admin/fund/balance/list', // 余额变动记录
    getTglist: '/admin/fund/candy/list', // 糖果变动记录

    getIntegralstatistics: '/admin/fund/integral/sum/list',

    getRebateKpiList: '/admin/fund/rebate/kpi/list',

    // 订单
    orderList: '/admin/order/list', // 订单列表
    orderDetail: '/admin/order/info', // 订单详情
    afterList: '/admin/after/sale/list', // 售后列表
    afterDetail: '/admin/after/sale/info', // 售后详情
    afterExamine: '/admin/after/sale/examine', // 订单审核
    importOrder: '/admin/order/delivery', // 订单导入

    // 售后
    getAfterSaleList: '/admin/order/after/sale/list',
    getAfterSaleList2: '/admin/order/after/sale/service/list',
    getAfterSaleFinancialList: '/admin/order/after/sale/financial/list',
    agreeAfterSale: '/admin/order/after/sale/service/agree',
    rejectAfterSale: '/admin/order/after/sale/service/reject',
    afterSaleInfo: '/admin/order/after/sale/info',
    agreeAfterSale2: '/admin/order/after/sale/agree/refund',
    rejectAfterSale2: '/admin/order/after/sale/financial/reject',
    changeAfterSaleAmount: '/admin/order/after/sale/change/amount',
    sendHistory: '/admin/order/after/sale/send/history',

    getDataSum: '/admin/rebate/data/sum',

    // 商家管理
    getBusinessTypeList: '/admin/shop/type/list',
    updateBusinessType: '/admin/shop/type/update',
    deleteBusinessType: '/admin/shop/type/delete',
    addBusinessType: '/admin/shop/type/add',

    getBusinessApplyList: '/admin/shop/manage/list', // 商家审核列表
    businessApplyResolve: '/admin/shop/manage/pass', // 商家审核审核通过
    businessApplyReject: '/admin/shop/manage/refuse', // 商家审核审核拒绝
    businessApplyInfo: '/admin/shop/manage/res', // 商家审核详情

    xxRechargeList: '/admin/fund/balance/offline/recharge/list', // 线下充值审核记录
    xxRechargeAudit: '/admin/fund/balance/offline/recharge/audit', // 线下充值审核

    updatePhone: '/admin/user/phone/update', // 修改用户手机号

    updateBalance: '/admin/user/balance/update', // 修改余额
    updateIntegral: '/admin/user/integral/update', // 修改余额
    updateHq: '/admin/fund/gold/update', // 修改悦贝
    updateHz: '/admin/fund/integral/update',
    updateTg: '/admin/fund/candy/update', // 扣除糖果

    getGroupSum: '/admin/fund/get/group/sum', // 查询团队数据统计

    getDataSum2: '/admin/fund/gold/integral/data/sum', // 资金数据统计

    deleteBusiness: '/admin/goods/merchant/delete',
    addBusiness: '/admin/goods/merchant/add',
    updateBusiness: '/admin/goods/merchant/update',
    getBusinessList: '/admin/goods/merchant/list',

    // 消息管理
    getMessageList: '/admin/fund/purchase/list',
    deleteMessage: '/admin/fund/purchase/delete',
    passMessage: '/admin/fund/purchase/audit/pass',
    refuseMessage: '/admin/fund/purchase/audit/refuse',
    getMessageDetail: '/admin/fund/purchase/info',

    getPayList: '/admin/pay/info/list',
    createPay: '/admin/pay/info/create',
    // uploadPay: '/admin/pay/info/upload',

    bindRemindList: '/admin/order/notify/manager/list',
    bindRemind: '',
    unbindRemind: '/admin/order/notify/unbind/manager',
    getBindCode: '/common/wx/mini/code',

    getUserTree: '/admin/user/tree',

    getUserSettingInfo1: '/admin/setup/control/team/info',
    getUserSettingInfo2: '/admin/setup/control/people/info',
    setUserSetting1: '/admin/setup/control/team/update',
    setUserSetting2: '/admin/setup/control/people/update',

    getKpiList: '/admin/head/turnover/list',

    getFundTypeMap: '/admin/fund/type/map',

    getWxPayList: '/admin/pay/wx/income/info/list',






    //商家商品
    getShopGoodsList: '/admin/goods/shop/list',
    getShopGoodInfo: '/admin/goods/info',
    rejectShopGood: '/admin/goods/shop/audit/reject',
    passShopGood: '/admin/goods/shop/audit/pass',




    getArticleCategoryList: '/admin/classroom/sort/list',
    addArticleCategory: '/admin/classroom/sort/add',
    deleteArticleCategory: '/admin/classroom/sort/delete',
    updateArticleCategory: '/admin/classroom/sort/update',

    getArticleList: '/admin/classroom/article/list',
    addArticle: '/admin/classroom/article/add',
    deleteArticle: '/admin/classroom/article/delete',
    updateArticle: '/admin/classroom/article/update',
    getArticleInfo: '/admin/classroom/article/info',


    getPosterInfo: '/admin/classroom/poster/info',
    updatePoster: '/admin/classroom/poster/update',


    //系统
    addSystem: '/admin/setup/company/add',
    getSystemList: '/admin/setup/company/list',
    getAreaName: '/admin/freight/name/list',



    getPayList: '/admin/pay/merchant/info/list',
    createPay: '/admin/pay/merchant/info/create',


    getOrderSalesList: '/admin/order/sales/list',

    addQuota: '/admin/quota/set/add',
    getQuota: '/admin/quota/set/info',
    addIntergral: '/admin/quota/set/add/integral',

    getVicePresidentSet: '/admin/user/vice/president/set',



    getFinancialCountingType: '/admin/fund/financial/counting/types',
    getFundDividendList: '/admin/fund/dividend/list',

    getFundTotalSum: '/admin/fund/total/sum',
    getFundPayDaySum: '/admin/fund/pay/day/sum',
    getFundPayMonthSum: '/admin/fund/pay/month/sum',

    getFundSysPayMonthSum: '/admin/fund/sys/pay/month/sum',
    getFundSysTotalSum: '/admin/fund/sys/total/sum',

    // 提现
    getKpiWithdrawList: '/admin/draw/kpi/log/list',
    getKpiWithdrawInfo: '/admin/draw/kpi/log/info',
    refuteKpiWithdraw: '/admin/draw/kpi/log/refute',
    passKpiWithdraw: '/admin/draw/kpi/log/pass',

    updateSuperior: '/admin/user/set/superior',


    updateAgreement: '/admin/agreement/update',
    getAgreementInfo: '/admin/agreement/info',

    //动态
    getDynamicsList: '/admin/setup/news/list',
    getDynamicsInfo: '/admin/setup/news/info',
    addDynamics: '/admin/setup/news/add',
    deleteDynamics: '/admin/setup/news/delete',

    getWxCategoryList: '/admin/goods/wx/channels/category/list',
    getWxCategoryInfo: '/admin/goods/wx/channels/category/info',
    syncProduct: '/admin/goods/wx/channels/sync/product',
    getIntegralLog: '/admin/fund/integral/log',

    getKpiRecordList: '/admin/kpi/list',

    // 活动专区
    getActivityList: '/admin/goods/activity/list',
    updateActivity: '/admin/goods/activity/update',
    deleteActivity: '/admin/goods/activity/delete',
    associationActivity: '/admin/goods/activity/association',
    disassociationActivity: '/admin/goods/activity/disassociate',
    updateActivityTwig: '/admin/goods/activity/update/map/twig',

    getAgreementList: '/admin/agreement/list',
    getAgreementInfo: '/admin/agreement/info',
    addAgreement: '/admin/agreement/add',
    updateAreement: '/admin/agreement/update',
    deleteAreement: '/admin/agreement/delete',

    getTpOrderList: '/admin/order/tp/list',
	getTpOrderDetail: '/admin/order/tp/info',


    //品牌
    getBrandList: '/admin/goods/brand/list',
    addBrand: '/admin/goods/brand/create',
    deleteBrand: '/admin/goods/brand/del',
    updateBrand: '/admin/goods/brand/update',
    batchUpdateBrand: '/admin/goods/brand/map/update',
    getBrandMap: '/admin/goods/brand/map/list',


    getBrandRoleList: '/admin/brand/role/set/list',
    updateBrandRole: '/admin/brand/role/set/update',
    deleteBrandRole: '/admin/brand/role/set/delete',


    // 品牌提现
    getBrandWithdrawList: '/admin/draw/brand/log/list',
    getBrandWithdrawInfo: '/admin/draw/brand/log/info',
    refuteBrandWithdraw: '/admin/draw/brand/log/refute',
    passBrandWithdraw: '/admin/draw/brand/log/pass',


    getBrandRecordList: '/admin/fund/brand/list'
};